import { updateContactTypes } from '../../../hooks/useContactQueries';
import {
  Contact,
  ContactListItem,
  ContactType, ContactTypeRole, ContactTypeRoleLevels,
} from '../../../Types';

interface AssignContactTypesState {
  contact: Contact | ContactListItem,
  action: string,
  force: boolean,
}

function getContactTypeMapKey(service: string, role_area: string, level?: string | undefined, contact_level?: string | undefined): string {
  let key = `${service}~${role_area}`;
  if (level) key += `~${level}`;
  if (contact_level) key += `~${contact_level}`;
  return key;
}

async function savePriorityLevels(contactId: string, location: string, contactTypes:ContactType[]) {
  const dataArray:any[] = [];

  contactTypes.forEach((contact_type:ContactType) => {
    const serviceName = contact_type.service;
    contact_type.role_areas.forEach((role_area: ContactTypeRole) => {
      const roleAreaName = role_area.role_area;
      role_area.levels.forEach((level: ContactTypeRoleLevels) => {
        const levelName = level.level;
        dataArray.push({
          contactId,
          service: serviceName,
          roleArea: roleAreaName,
          level: levelName,
          action: 'add',
        });
      });
    });
  });

  const data:any = {
    data: dataArray,
  };

  return updateContactTypes(location, data);
}

async function saveReassignments(location: string, reassignmentsMap:Map<string, ContactListItem | Contact>) {
  const dataArray:any[] = [];

  reassignmentsMap.forEach((contact: ContactListItem | Contact, key:string) => {
    const cTypesData:string[] = key.split('~');
    dataArray.push(
      {
        contactId: contact.id,
        service: cTypesData.shift(),
        roleArea: cTypesData.shift(),
        level: cTypesData.shift(),
        action: 'add',
      },
    );
  });

  const data:any = {
    data: dataArray,
  };

  return updateContactTypes(location, data);
}

export {
  getContactTypeMapKey,
  savePriorityLevels,
  saveReassignments,
};

export type { AssignContactTypesState };
